import get from "lodash/get";

import { IMPORT_QUESTIONNAIRE, RESET, } from "../types";

export default function(state = [], action) {
  switch (action.type) {
    case IMPORT_QUESTIONNAIRE:
      return get(action, ['payload', 'distribution'], []);

    case RESET:
      return [];

    default:
      return state;
  }
}
